<template>
  <div>
    <div v-if="currentNews">
      <div class="current-news-item-container">
        <h1 v-html="currentNews?.Title"></h1>
        <div class="main-content" v-html="currentNews?.Text?.Html"></div>
        <form-button text="Ota yhteyttä" theme="primary" @click.native="openContactForm('contact-full')"></form-button>
      </div>

      <dialogue identifier="contact-full">
        <template #dialogueContent>
          <agency-contact formVersion="full"></agency-contact>
        </template>
      </dialogue>
    </div>
    <loading v-else-if="isPending"></loading>
    <error-message v-else="error" class="error" :retry="true"></error-message>
  </div>
</template>

<script lang="ts">
import * as actions from '@/app/store/action-types';
import config from '@/config';
import { computed, defineAsyncComponent, ref } from 'vue';
import Loading from '@/app/components/loading/loading.vue';
import ErrorMessage from '@/app/components/error-message/error-message.vue';
import useNewsNew from '../../data/useNewsNew';
import useSafeRoute, { getRouteParamAsString } from '../../composables/useSafeRoute';

export default {
  name: 'currentNewsItem',
  setup() {
    const route = useSafeRoute();
    const page = computed(() => {
      return getRouteParamAsString(route.value.params.id) || '';
    });
    const pageRef = ref(page.value);

    const { data, isPending, error } = useNewsNew(pageRef);

    const currentNews = computed(() => (!!data.value?.length ? data.value[0] : undefined));

    return { currentNews, isPending, error };
  },
  methods: {
    openContactForm(section: string) {
      // @ts-ignore
      this.$bus.$emit('openDialogue', section);
    },
  },
  mounted() {
    void this.$store.dispatch(actions.analytics.set, {
      pageName: `etusivu:uutiset`,
      eVar17: 'Uutiset - OP Koti',
    });
    void this.$store.dispatch(actions.analytics.track, config.analytics.eventTypes.pageView);
  },
  components: {
    FormButton: defineAsyncComponent(() => import('@/app/components/form-button/form-button.vue')),
    Dialogue: defineAsyncComponent(() => import('@/app/components/dialogue/dialogue.vue')),
    AgencyContact: defineAsyncComponent(() => import('@/app/components/agency-contact/agency-contact.vue')),
    Loading,
    ErrorMessage,
  },
};
</script>
